"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteOutlined = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var DeleteOutlined = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 5.5v-1a.5.5 0 00-.5-.5H15V3a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zM7.72 18h8.56L17 8h2l-.85 12.14a2 2 0 01-2 1.86H7.87a2 2 0 01-2-1.86L5 8h2l.72 10z", clipRule: "evenodd" })); };
exports.DeleteOutlined = DeleteOutlined;
//# sourceMappingURL=delete-outlined.js.map